import { apiFetch } from './api';
import type { Story } from '../types/models';

export function listStories(): Promise<Story[]> {
  return apiFetch<Story[]>('/stories');
}
